import type { SidebarType } from '@/types/shared'
import { purchasingPaymentPaths } from './paths'

export const purchasingPaymentNav = {
    purchase: {
        title: 'purchasing-payments:type.purchase',
        path: purchasingPaymentPaths.purchasingPurchases,
        ignorePermission: true,
    },
    advance: {
        title: 'purchasing-payments:type.advance',
        path: purchasingPaymentPaths.purchasingAdvances,
        ignorePermission: true,
    },
    expense: {
        title: 'purchasing-payments:type.expense',
        path: purchasingPaymentPaths.purchasingExpenses,
        ignorePermission: true,
    },
} satisfies Record<string, SidebarType>
